// Return-path query data may outlive older client builds or interrupted logins.
export function parseLoginReturnQuery(raw) {
  try {
    const value = JSON.parse(raw);
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  } catch (error) {
    return {};
  }
}
